import {Visit} from "./Bag";

function getPeopleList(peopleArray: string[]) {
    if (!peopleArray || !peopleArray.length) {
        return "On my own";
    }
    const maxIdx = peopleArray.length - 1;
    return (
        "With " +
        peopleArray.reduce((acc, cur, idx) => {
            if (idx === 0) {
                return acc + " " + cur;
            }
            if (idx === maxIdx) {
                return acc + " & " + cur;
            }
            return acc + ", " + cur;
        }, "")
    );
}

export const getWhoDIV = (
    v: Visit,
    hillID: number
): HTMLDivElement | undefined => {
    if (v.with?.length) {
        const who = document.createElement("div");
        who.textContent = getPeopleList(v.with);
        return who;
    }

    if (v.withParts?.length) {
        const who = document.createElement("div");
        const people = v.withParts
            .filter((i) => i.ids.includes(hillID))
            .flatMap((i) => i.with);
        who.textContent = getPeopleList(people);
        return who;
    }

    return;
};
